import React, { useState, useEffect } from 'react';
import PricingTable from '.';
import Section from '../Div';
import Spacing from '../Spacing';
import useFetchPlans from '../../hooks/useFetchPlans';
import { ProgressSpinner } from 'primereact/progressspinner';
import axiosInstance from '../../api/axiosRest';
import { PAYMENT } from '../../api/urls';

export default function PricingTableList({ excludePlanId }) {
  const [tab, setTab] = useState('monthly');
  const { plans, loading, error } = useFetchPlans();
  const [trialSettings, setTrialSettings] = useState({ trial_enabled: false, trial_days: 0 });

  useEffect(() => {
    const fetchTrialSettings = async () => {
      try {
        const response = await axiosInstance.get(PAYMENT.TRIAL_SETTINGS);
        setTrialSettings(response.data);
      } catch (err) {
        console.log('Could not fetch trial settings:', err);
      }
    };
    fetchTrialSettings();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '200px' }}
      >
        <ProgressSpinner
          style={{ width: '50px', height: '50px' }}
          strokeWidth="8"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center">
        Failed to load plans. Please try again later.
      </div>
    );
  }

  const filteredPlans = plans.filter((plan) => {
    if (excludePlanId && plan.id === excludePlanId) {
      return false;
    }

    if (excludePlanId) {
      return true;
    }

    if (tab === 'monthly') {
      return (
        plan.name.toLowerCase() === 'standard' ||
        plan.name.toLowerCase() === 'monthly'
      );
    } else if (tab === 'yearly') {
      return plan.name.toLowerCase() === 'yearly';
    }

    return false;
  });

  return (
    <Section className="position-relative">
      {!excludePlanId && (
        <Section className="d-flex justify-content-center mb-4">
          <ul className="cs-tab_links cs-style1 cs-mp0 cs-primary_font d-flex">
            <li
              className={tab === 'monthly' ? 'active mr-3' : 'mr-3'}
              onClick={() => setTab('monthly')}
              style={{ cursor: 'pointer' }}
            >
              Monthly
            </li>
            <li
              className={tab === 'yearly' ? 'active' : ''}
              onClick={() => setTab('yearly')}
              style={{ cursor: 'pointer' }}
            >
              Yearly
            </li>
          </ul>
        </Section>
      )}

      {/* Free Trial Banner - positioned after tabs */}
      {trialSettings.trial_enabled && !excludePlanId && (
        <Section className="text-center" style={{ marginBottom: '20px' }}>
          <div style={{
            background: 'linear-gradient(135deg, #00DFA2 0%, #00b386 100%)',
            color: '#000',
            padding: '12px 30px',
            borderRadius: '6px',
            display: 'inline-block',
            fontSize: '15px',
            fontWeight: '600'
          }}>
            {trialSettings.trial_days}-Day FREE Trial — No charge until trial ends
          </div>
        </Section>
      )}

      <Section className="row" style={{ marginTop: trialSettings.trial_enabled ? '0' : '-10%' }}>
        <Section className={excludePlanId ? '' : 'col-lg-4 mx-auto'}>
          {filteredPlans.length > 0 ? (
            filteredPlans.map((plan) => (
              <PricingTable
                key={plan.id}
                title={plan.description}
                price={plan.price}
                currency="$"
                timeline={!excludePlanId ? tab : undefined}
                features={Object.values(plan.features)}
                btnText={trialSettings.trial_enabled ? "Start Free Trial" : "Purchase Now"}
                price_id={plan.stripe_price_id}
                discounted={plan.is_discounted}
                discount_percentage={plan.discount_percentage}
                trialEnabled={trialSettings.trial_enabled}
                trialDays={trialSettings.trial_days}
              />
            ))
          ) : (
            <p className="text-center">No available plans to subscribe.</p>
          )}
          <Spacing lg="25" md="25" />
        </Section>
      </Section>
    </Section>
  );
}
